<template>
	<nav-tabs :tabs="tabs" :active-index="activeTabIndex"></nav-tabs>
</template>
<script type="text/javascript">
import NavTabs from "@/layout_fragments/NavTabs"

export default {
	name: "FinancialNavTabs",
	components: {
		NavTabs
	},
	data() {
		return {
			tabs: [
				{
					label: "Invoices",
					icon: "fa-file-invoice-dollar",
					path: "/financial/invoices",
					anyModulePerms: ["Service Quotes/Invoices","Job Invoices"]
				},
				{
					label: "Project Holdbacks",
					icon: "fa-file-invoice-dollar",
					path: "/financial/project-holdbacks",
					modulePermRequired: ["Projects"]
				}
			]
		}
	},
	computed: {
		activeTab() {
			return this.tabs.find(tab => tab.path == this.$route.fullPath)
		},
		tabTitle() {
			if (this.activeTab)
				return this.activeTab.label.toUpperCase()

			return ""
		},
		activeTabIndex() {
			return this.tabs.findIndex(tab => tab.path == this.$route.fullPath)
		}
	}
}
</script>